import React, { useEffect } from 'react';

export default function LightboxModal({ images = [], currentIndex = 0, isOpen, onClose, onNavigate }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') onNavigate((currentIndex + 1) % images.length);
      if (e.key === 'ArrowLeft') onNavigate((currentIndex - 1 + images.length) % images.length);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, currentIndex, images.length, onClose, onNavigate]);

  if (!isOpen || images.length === 0) return null;

  const currentImg = images[currentIndex];

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 backdrop-blur-md transition-opacity"
      onClick={onClose}
    >
      <div 
        className="relative flex max-h-[90vh] max-w-5xl flex-col items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
          aria-label="Luk billede"
        >
          <i className="fa-solid fa-xmark text-xl" />
        </button>

        {/* Main image */}
        <div className="relative overflow-hidden rounded-lg shadow-2xl">
          <img
            src={currentImg}
            alt={`Billede ${currentIndex + 1}`}
            className="max-h-[80vh] w-auto max-w-full object-contain select-none"
          />
        </div>

        {/* Counter */}
        <div className="mt-4 text-sm font-medium text-white/80">
          {currentIndex + 1} / {images.length}
        </div>

        {/* Navigation arrows */}
        {images.length > 1 && (
          <>
            <button
              onClick={() => onNavigate((currentIndex - 1 + images.length) % images.length)}
              className="absolute left-2 top-1/2 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full bg-black/60 text-white hover:bg-[#d92323] transition-colors"
              aria-label="Forrige billede"
            >
              <i className="fa-solid fa-chevron-left text-lg" />
            </button>
            <button
              onClick={() => onNavigate((currentIndex + 1) % images.length)}
              className="absolute right-2 top-1/2 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full bg-black/60 text-white hover:bg-[#d92323] transition-colors"
              aria-label="Næste billede"
            >
              <i className="fa-solid fa-chevron-right text-lg" />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
